export default "__VITE_ASSET__069624cd__"